import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete';

import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import { useEffect, useMemo, useRef, useState } from 'react';
import './index.css';
import { Select, Spin } from 'antd';
const Places = (props) => {
  const [loading, setLoading] = useState(false);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyDQHsmzLosPoXC1sEGJkf9iVdIdLlC12UE',
    libraries: ['places'],
  });

  if (!isLoaded) return <div>Loading...</div>;

  return <Spin spinning={loading} >
    <Map {...props} setLoading={setLoading} />
  </Spin>
}

const Map = (props) => {
  const position = { lat: 35.652832, lng: 139.839478 };

  // const [selected, setSelected] = useState(props.lat && props.lng ? { lat: Number(props.lat), lng: Number(props.lng) } : null);

  const [selected, setSelected] = useState(null);
  useEffect(() => {
    const { lat, lng } = props;
    if (lat && lng) {
      setSelected({ lat: Number(lat), lng: Number(lng) });
    }
  }, [props]);
  // useEffect(() => {
  //   getLatLng();
  // }, [])
  return (
    <div className="places-container">
      <div className="places">
        <PlacesAutoComplete {...props} setSelected={setSelected} />
      </div>
      <GoogleMap
        zoom={selected ? 17 : 12}
        center={selected ?? position}
        mapContainerClassName="map-container"
        // fullscreenControl={false}
      >
        {
          selected && <Marker position={selected} />
        }
      </GoogleMap>
    </div>
  );
};

const PlacesAutoComplete = (props) => {
  // const {
  //   ready,
  //   value,
  //   setValue,
  //   suggestions: { status, data },
  //   clearSuggestions,
  // } = usePlacesAutocomplete({
  //   requestOptions: {
  //     language: "ja"
  //   }
  // });

  const [value, setVal] = useState("");
  const [data, setData] = useState([]);
  const containerRef = useRef();

  const isSearchRef = useRef(true);

  const clearSuggestions = () => {
    setData([]);
  }

  const setValue = (data: string, isSearch = true) => {
    setVal(data);

    isSearchRef.current = isSearch;
  }

  const handleSearch = (value: string) => {
    setValue(value);
  };

  const handleSelect = async (address: string) => {
    setValue(address, false);
    clearSuggestions();

    props.setLoading(true);
    const result = await getGeocode({ address });
    const { lat, lng } = await getLatLng(result[0]);
    props.setLoading(false)

    props.onSelect({ lat, lng, address });
    props.setSelected({ lat, lng });
  }

  const location = useMemo(() => {
    const location = props.location;
    if (location) {
      if (Array.isArray(location)) {
        return location.join(" ");
      } else {
        return location;
      }
    }
  }, [props.location])

  useEffect(() => {
    if (location) {
      if (Array.isArray(location)) {
        setValue(location.join(" "));
      } else {
        setValue(location)
      }
    }
  }, [location])

  useEffect(() => {
    if (value) {

      if (isSearchRef.current) {
        const fn = new window.google.maps.places.AutocompleteService();
        fn.getPlacePredictions({
          input: value,
          language: "ja"
        }).then(res => {
          console.log(res, "res")
          setData(res.predictions! as any[]);
        })
      }
    }
  }, [value])

  return (
    <div ref={containerRef}>
      {/* <Select /> */}
      <Select
        showSearch
        // value={value}
        defaultValue={value ? value : location}
        // placeholder={props.placeholder}
        // style={props.style}
        defaultActiveFirstOption={false}
        suffixIcon={null}
        filterOption={false}
        onSearch={handleSearch}
        notFoundContent={null}
        options={(data || []).map(({ place_id, description }) => ({
          value: description,
          label: description,
        }))}
        open={!!((data || []).length)}
        style={{ width: "100%" }}
        onSelect={handleSelect}
        getPopupContainer={() => containerRef.current}
      />
      {/* <Input value={value} onChange={(e) => setValue(e.target.value)} /> */}
    </div>
  )
}

export default Places;
